export function getImgAspectRatio(img, newHeight, newWidth) {
    var _a;
    var oldHeight = img.height, oldWidth = img.width;
    var isNewHeight = Boolean(newHeight);
    return _a = {},
        _a[(isNewHeight ? 'height' : 'width')] = (isNewHeight ? newHeight : newWidth),
        _a[(isNewHeight ? 'width' : 'height')] = (isNewHeight ? (newHeight * (oldWidth / oldHeight)) : (newWidth * (oldHeight / oldWidth))),
        _a;
}
